<script lang="ts">
  import { Button, Col, Badge } from "sveltestrap";
  import FeatherIcon from "svelte-feather-icon";
  import Card from "../UiCommenCard.svelte";
  import { Badgesaspartbuttons, Light, Messages } from "../../../utils/Constant/Constant";
  import data from "../../../Data/ComponentData/Ui-kits/TagsPills/TagsPills.json";
</script>

<Col sm="12" md="6">
  <Card cardProps="height-equal" cardHeaderprops="pb-0" headerTitle={Badgesaspartbuttons} >
    <div slot="contentbody">
      <div class="mb-3">
        <Button color="primary">{Messages} 
          <Badge pill color="light" class="text-dark">
            <FeatherIcon icon="mail" />
          </Badge>
        </Button>
      </div>
      {#each data.Badgesasbuttondata as badgeItem}
        <div class="mb-3">
          <Button color={badgeItem.color}>{badgeItem.btnName}
            <Badge pill  color="light" class="text-dark">
              <FeatherIcon icon={badgeItem.icon} />
            </Badge>
          </Button>
        </div>
      {/each}
    </div>
  </Card>
</Col>
